/**
 * Icon images drawn in one dark colour (black / grey / near-black), which Theme
 * Studio repaints with the partner's Icons colour through the `zv-icon` class
 * (src/themeColors.scss + utils/iconFilter.ts). Brand-coloured, white and
 * multi-colour icons are not here, so `iconClass` leaves them alone.
 *
 * The lists live beside each registry (icons.ts, weatherIcon.ts).
 */
import { NEUTRAL_ICON_SRCS } from "./icons";
import { NEUTRAL_WEATHER_ICON_SRCS } from "./weatherIcon";

const NEUTRAL_ICONS = new Set<string>([...NEUTRAL_ICON_SRCS, ...NEUTRAL_WEATHER_ICON_SRCS]);

/** `"zv-icon"` for a dark single-colour icon image, else `""` — for components that render an icon they are handed. */
export const iconClass = (src: unknown): string => (typeof src === "string" && NEUTRAL_ICONS.has(src) ? "zv-icon" : "");
